import { LiveClassDto } from './LiveClassDto';

export enum OneSignalTags {
  LAST_LIVE_CLASS_TAKEN = 'last-live-class-taken',
  LAST_PRIVATE_CLASS_TAKEN_COLLECTION = 'last-private-class-taken-collection',
  LAST_GROUP_CLASS_TAKEN_TEACHER = 'last-group-class-taken-teacher',
  LAST_CLASS_RATING = 'last-class-rating',
  LAST_JENNY_CONVERSATION_INITIATED = 'last-jenny-conversation-initiated',
  LAST_JENNY_CHAT_INITIATED = 'last-jenny-chat-initiated',
  LAST_JENNY_CONVERSATION_CONCLUDED = 'last-jenny-conversation-concluded',
  LAST_LESSON_COMPLETED_TIMESTAMP = 'last-lesson-completed-timestamp',
  LAST_PRACTICE_COMPLETED_TIMESTAMP = 'last-practice-completed-timestamp',
  LAST_PRACTICE_COMPLETED_TYPE = 'last-practice-completed-type',
  LAST_LESSON_COMPLETED_NAME = 'last-lesson-completed-name',
  LAST_LESSON_COMPLETED_UNIT = 'last-lesson-completed-unit',
  LAST_COHORT_CLASS_TAKEN_TIMESTAMP = 'last-cohort-class-taken-timestamp',
  LAST_COHORT_CLASS_TAKEN_TYPE = 'last-cohort-class-taken-type',
  LAST_COHORT_CLASS_TAKEN_NAME = 'last-cohort-class-taken-name',
}

export const LastLiveClassTakenInterpolationKey = 'live';

export enum OneSignalLiveClassTakenType {
  GROUP = 'group',
  PRIVATE = 'private',
}

export enum OneSignalLiveClassTakenData {
  TIMESTAMP = 'timestamp',
  NAME = 'name',
  TYPE = 'type',
  TEACHER = 'teacher',
}

export const ClassTypeToOneSignalTypeMap = {
  'Private Class': OneSignalLiveClassTakenType.PRIVATE,
  'Live Class': OneSignalLiveClassTakenType.GROUP,
};

export const OneSignalLiveClassTakenDataMap: Partial<{
  [key in OneSignalLiveClassTakenData]: keyof LiveClassDto
}> = {
  [OneSignalLiveClassTakenData.TIMESTAMP]: 'classBegin',
  [OneSignalLiveClassTakenData.NAME]: 'title',
  [OneSignalLiveClassTakenData.TYPE]: 'subType'
};



// WEBPACK FOOTER //
// ./ts/app/shared/types/one-signal-tags.ts